import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "BMI",
    isNumber: true,
    isSum: true,
  },
];

export const SexToBMI = {
  label: "性別 vs BMI",
  key: "SexToBMI",
  path: "BMI/SexToBMI",
  api: "TCS_V_BMIItemsV",
  render: (options) => <Diagram.BMI.SexToBMI {...options} />,
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "性別",
      field: "性別",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
